import { ApprovalsListResponse } from '@Types/api/approvalsList';

interface ReturnValue {
  essList: ApprovalsListResponse[];
  mrList: ApprovalsListResponse[];
}

const sortRequests = (
  listRequests: ApprovalsListResponse[]
): ApprovalsListResponse[] => {
  const copy = listRequests.map((item) => item);
  return copy.sort((a, b) =>
    b.details.created.localeCompare(a.details.created)
  );
};

const useSepareteRequest = (
  data: ApprovalsListResponse[] | undefined
): ReturnValue => {
  const essList: ApprovalsListResponse[] = [];
  const mrList: ApprovalsListResponse[] = [];

  if (Array.isArray(data) && data.length) {
    const listRequests = sortRequests(data);

    for (let i = 0; i < listRequests.length; i += 1) {
      const item = listRequests[i];
      const requestType = item.variables?.taskType?.value;

      if (requestType === 'MRRequest') {
        mrList.push(item);
      }

      if (requestType !== 'MRRequest' && requestType != null) {
        essList.push(item);
      }
    }
  }

  return {
    essList,
    mrList,
  };
};

export default useSepareteRequest;
